import Vue from 'vue'
import ProgressC from './components/ProgressC'
import MAlert from './components/MAlert'
import MButton from './components/MButton'
import MDatePicker from './components/MDatePicker'
import MDialog from './components/MDialog.vue'

Vue.component('progress-c', ProgressC)
Vue.component('m-button', MButton)
Vue.component('m-datepicker', MDatePicker)
Vue.component('m-dialog', MDialog)
Vue.component('m-alert', MAlert)
